import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ObrasProjeto } from '../models/obras-projeto.model';
import { BaseService } from 'src/app/base/services/base.service';
import { Observable } from 'rxjs';
import { PontosCriticosProjeto } from '../models/pontos-criticos-projeto.model';

@Injectable({
  providedIn: 'root'
})
export class PontosCriticosProjetoService extends BaseService<PontosCriticosProjeto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public indicadorList(id: number): Observable<PontosCriticosProjeto[]> {
    return this.http.get<PontosCriticosProjeto[]>(this.baseUrl + '/indicador-list/' + id, { headers: this.headers });
  }

  public agregadorIndicadorList(id: number): Observable<PontosCriticosProjeto[]> {
    return this.http.get<PontosCriticosProjeto[]>(this.baseUrl + '/agregador-indicador-list/' + id, { headers: this.headers });
  }

  public entregaList(id: number): Observable<PontosCriticosProjeto[]> {
    return this.http.get<PontosCriticosProjeto[]>(this.baseUrl + '/entrega-list/' + id, { headers: this.headers });
  }

  public getEntregaById(id: number): Observable<PontosCriticosProjeto> {
    return this.http.get<PontosCriticosProjeto>(this.baseUrl + '/entrega/' + id, { headers: this.headers });
  }

  public getIndicadorById(id: number): Observable<PontosCriticosProjeto> {
    return this.http.get<PontosCriticosProjeto>(this.baseUrl + '/indicador/' + id, { headers: this.headers });
  }

  public getOpcoesCombobox(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + '/opcoes-combobox', { headers: this.headers });
  }

  public solicitarNovaSituacao(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/nova-situacao/' + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/pontos-criticos';
  }
}
